export default __webpack_public_path__ + "static/media/mounting.2e0863c5.jpg";